import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogActions, DialogTitle } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import AppLanguageStorage from 'src/translations/AppLanguageStorage';

import CompaniesSelector from '../CompaniesSelector';
import loginPageKeys from '../../translations/loginPageKeys';

const lang = AppLanguageStorage.languageForLogin;

const styles = () => ({
  dialog: {
    overflow: 'inherit',
    padding: '20px 100px'
  },
  title: {
    display: 'flex',
    justifyContent: 'center'
  },
  actions: {
    marginBottom: 10,
    marginTop: 10,
    display: 'flex',
    justifyContent: 'center'
  }
});

function CompaniesDialog({
  isOpen,
  options,
  classes
}) {
  return (
    <Dialog
    open={isOpen}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
    PaperProps={{
      classes: {
        root: classes.dialog
      }
    }}
  >
      <DialogTitle id="alert-dialog-title" className={classes.title}>
        <span>{loginPageKeys[lang].reselectCompany}</span>
      </DialogTitle>
      <DialogActions className={classes.actions}>
        <CompaniesSelector
        options={options}
      />
      </DialogActions>
    </Dialog>
  );
}

CompaniesDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  options: PropTypes.array
};

CompaniesDialog.defaultProps = {
  options: []
};

export default withStyles(styles)(CompaniesDialog);
